/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { View } from 'okta';
import hbs from 'handlebars-inline-precompile';
import FactorUtil from 'util/FactorUtil';
export default View.extend({
  template: hbs`{{#if requirements}}
      <div class="password-requirements--header">
        {{i18n code="password.complexity.requirements.header" bundle="login"}}
      </div>
      <ul class="password-requirements--list">
          {{#each requirements}}<li class="password-requirements--list-item">{{this}}</li>{{/each}}
      </ul>
    {{/if}}`,

  attributes: {
    'data-se': 'password-requirements-html',
  },

  allRequirements: [],

  initialize: function(options) {
    const policy = options.policy;

    if (!policy) {
      return;
    }

    this.allRequirements = FactorUtil.getPasswordComplexityDescriptionForHtmlList(policy);
  },

  getTemplateData: function() {
    return {
      requirements: this.allRequirements,
    };
  },
});



// WEBPACK FOOTER //
// ./src/views/shared/PasswordRequirements.js